import React from 'react'
import { Spinner, Button } from 'react-bootstrap'
function LoadingSpinner() {
  return (
    <center style={{ marginTop: '20%' }}>
      <Button variant="primary" disabled>
        <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
        Loading...
      </Button>
    </center>
  )
}
export default LoadingSpinner
